import { useRouter } from "next/router"
import { useEffect, useCallback } from "react"
import { useToast } from "./toastProvider"
import { removeQueryParams } from "@common/lib/navigation"
import { useIsMounted } from "@common/hooks/useIsMounted"

interface ToastFromURLProps {
  successMessage?: string
  failureMessage?: string
  queryStr?: string
}

export function ToastFromURL({
  successMessage = "Success",
  failureMessage = "Failed",
  queryStr = "toast",
}: ToastFromURLProps) {
  const { showToast } = useToast()
  const router = useRouter()
  const getIsMounted = useIsMounted()

  const { [queryStr]: toastType } = router.query

  const removeQuery = useCallback(() => {
    if (toastType && getIsMounted()) {
      const path = removeQueryParams(router.asPath, queryStr)
      router.replace(path)
    }
  }, [router, toastType, queryStr])

  useEffect(() => {
    if (toastType) {
      const isSuccess = toastType === "success"
      showToast({
        message: isSuccess ? successMessage : failureMessage,
        type: isSuccess ? "success" : "error",
        onClose: removeQuery,
      })
    }
  }, [toastType, successMessage, failureMessage, showToast, removeQuery])

  return <></>
}
